/* Fluidité sur ordinateur (Mac Retina, cartes graphiques intégrées) : le site se comporte comme sur téléphone,
   où il est fluide — pas de curseur personnalisé, pas d'inclinaison 3D des cartes ni de boutons « magnétiques »,
   et les animations sur canvas (neige, étoiles) calculées en résolution standard. */
(function(){
  try{
    if(window.matchMedia){
      var mm=window.matchMedia.bind(window);
      window.matchMedia=function(q){
        if(/pointer:\s*fine/.test(q)&&/hover:\s*hover/.test(q))return{matches:false,media:q,addListener:function(){},removeListener:function(){},addEventListener:function(){},removeEventListener:function(){},onchange:null,dispatchEvent:function(){return false;}};
        return mm(q);
      };
    }
    if(window.innerWidth>=900)Object.defineProperty(window,'devicePixelRatio',{get:function(){return 1;},configurable:true});
    /* mêmes visuels sans flou ni fusion recalculés à chaque image (ce qui fait ramer les Mac) */
    var st=document.createElement('style');
    st.textContent='@media (min-width:900px){.hero__aurora,.hero__aurora--2{filter:none!important;mix-blend-mode:normal!important;will-change:transform}[data-sky="day"] .hero__tint{mix-blend-mode:normal!important}.about__glow,.about__glow--2,.about__glow--3{mix-blend-mode:normal!important}}';
    (document.head||document.documentElement).appendChild(st);
  }catch(e){}
})();
document.addEventListener('DOMContentLoaded',function(){
  var b=document.querySelector('.hdr__burger');
  var d=document.getElementById('drawer');
  if(!b||!d)return;
  var closeBtn=d.querySelector('.drawer__close');
  var overlay=d.querySelector('.drawer__overlay');
  function open(){d.classList.add('open');b.setAttribute('aria-expanded','true');d.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';}
  function close(){d.classList.remove('open');b.setAttribute('aria-expanded','false');d.setAttribute('aria-hidden','true');document.body.style.overflow='';}
  b.addEventListener('click',open);
  if(closeBtn)closeBtn.addEventListener('click',close);
  if(overlay)overlay.addEventListener('click',close);
  d.querySelectorAll('.drawer__nav a').forEach(function(a){a.addEventListener('click',close);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
});